<template>
    <div class="title-warpper flex align-center justify-between padding-tb-xs">
        <div class="title-text flex align-center">
            <i class="iconfont " :class="iconfont"></i>
            <p v-html="pageTitle"></p>
        </div>
        <el-button size="small" type="primary" v-if="isBack" @click="back">
            返回上一页
        </el-button>
        <h3 v-else class="wecome">您好，<span>{{user ? user.user_name : ''}}</span>，欢迎使用北京消防协会会员信息系统！</h3>
    </div>
</template>

<script>
export default {
    name: "title-modular",
    data() {
        return {}
    },
    props: {
        pageTitle: {
            type: String,
            default: ''
        },
        iconfont: {
            type: String,
            default: ''
        },
        isBack: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        back() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped lang="scss">
.title-warpper {
    display: flex;
    align-items: center;
    height: 60px;
    font-size: 16px;

    .title-text {
        color: #667fa0;

        i {
            font-size: 20px;
            margin-right: 10px;
        }
    }
    .wecome{
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        span{
            color: #0d7fd7;
        }
    }
}
</style>